import React from 'react'
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import PicCont from '../components/PicCont';
import SinglePack from '../components/SinglePack';
import NotSure from '../components/NotSure';
import SimilarCats from '../components/SimilarCats';
import Carrousel from '../components/Carrousel';
import ProductList from '../components/ProductList';
import LandingCategories from '../components/LandingCategories';
import { useDispatch, useSelector } from 'react-redux';
import { wrapper } from '../store/configStore';
import { SERVER_IP } from '../store/middleware/api';
import axios from 'axios';
import ClientReviews from '../components/ClientReviews';
import PastEvents from '../components/PastEvents';
import { getFilteredProducts, productsReceived, productsSetFilters } from '../store/slices/entities/products';
import { getAllPackages, packagesReceived } from '../store/slices/entities/packages';
import lightingRentalHeroV2 from '../public/Pictures/categories-v2/lighting-rental-hero-v2.jpg'
import lighting_a from '../public/Pictures/lighting-a.jpg'
import lighting_b from '../public/Pictures/lighting-b.jpg'
import lighting_c from '../public/Pictures/lighting-c.jpg'
import lightingtop from '../public/Pictures/lightingtop.jpg'
import speakers_b from '../public/Pictures/speakers-b.jpg'
import ss_c from '../public/Pictures/subwoofer_v.jpg'
import LinkWrap from '../components/LinkWrap';
import BGBlock from '../components/BGBlock';
import PageShell from '../components/design-system/foundations/PageShell';
import ServiceHero from '../components/design-system/marketing/ServiceHero';
import ServiceOverview from '../components/design-system/marketing/ServiceOverview';
import RentalFAQV2 from '../components/design-system/marketing/RentalFAQV2';
import QuotePop from '../components/DeferredQuotePopup';
import { SHOW_POPUP } from '../store/slices/ui';
import { FiMessageCircle } from '@react-icons/all-files/fi/FiMessageCircle';
import { FiSun } from '@react-icons/all-files/fi/FiSun';
import * as gtag from '../lib/gtag';
import { compactCatalogProducts, compactPublicCatalogPackages } from '../utilities/catalogPublicPayload';
import { compactPublicEvents } from '../utilities/eventPublicPayload';
import MarketCoverageNotice from '../components/design-system/marketing/MarketCoverageNotice';

const sharedCatalogCoverage = {
    ariaLabel: 'Miami and Orlando catalog information',
    heading: 'Two Florida storefronts',
    body: 'Your selected Miami or Orlando store determines the inventory, pickup, delivery and availability shown on this shared equipment page.',
    cta: false
}

const lightingOverviewContent = {
    id: 'lighting-rental-overview',
    density: 'compact',
    headingLevel: 'h3',
    heading: 'Looking to rent Lighting for your next event?',
    body: [
        'Professional event lighting from our Miami and Orlando teams',
        'Perfect for weddings, private parties, DJ shows, and corporate presentations. Our professional team specializes in creating the ideal ambiance, ensuring every occasion, from lively celebrations to formal conferences, is brilliantly illuminated.',
        'Discover our diverse lighting options and let us transform your event into an unforgettable experience.'
    ],
    media: { src: lightingtop, alt: '' }
}

const lightingPackagesOverviewContent = {
    id: 'lighting-rental-packages',
    density: 'compact',
    headingLevel: 'h3',
    heading: 'Want to rent Lighting for your next event?',
    body: [
        'Check out our special discounts on pre-made lighting packages.',
        <ol key='package-types'>
            <li><strong>Wedding lighting:</strong> Rent wireless uplights to illuminate your special day. Our selection includes indoor and outdoor uplighting in various models in all price ranges.</li>
            <li><strong>Stage lighting:</strong> Rent concert lighting fixtures such as moving heads, wash lights, spotlights, and other party lights.</li>
        </ol>
    ],
    media: { src: lighting_a, alt: '' }
}
export const getStaticProps = wrapper.getStaticProps(
    async ({ store, preview }) => {
        const res = await axios.request(`${SERVER_IP}/inventory/pack/tag?tag=lighting`)
        const corp = await axios.request(`${SERVER_IP}/user/static-landing`)
            const faq = await axios.request(`${SERVER_IP}/faq?category=Lighting`)
        const subCate = await axios.request(`${SERVER_IP}/subcategory/name/up-lighting?cat=lighting`)
        // This page only renders lighting bundles. Fetching every bundle category
        // inflated the static HTML with products that could never be displayed.
        const products = await axios.request(`${SERVER_IP}/inventory/product?msr=true&cat=lighting&subcat=bundle`)

        store.dispatch({ type: productsReceived.type, payload: compactCatalogProducts(products.data) })

        store.dispatch({ type: productsSetFilters.type, payload: { static: true } })
        if (res.data) store.dispatch({ type: packagesReceived.type, payload: compactPublicCatalogPackages(res.data) })

        let { newsletterevents, total_events } = corp?.data
        return {
            props: {
                newsletterevents: compactPublicEvents(newsletterevents), total_events, subCate: subCate.data, faq: faq.data
            }
        }
    }
);

const LightingRental = ({ newsletterevents, total_events, subCate, faq }) => {
    let products = useSelector(getFilteredProducts)
    let packages = useSelector(getAllPackages)
    const dispatch = useDispatch()
    const openQuote = () => {
        gtag.event({ action: 'quote_click', label: 'leads', value: 3, category: 'orders' })
        dispatch(SHOW_POPUP({
            key: 'quote',
            size: 'medium',
            body: <QuotePop />
        }))
    }
    const heroSteps = [
        { icon: 'search', title: 'Choose your lighting', description: 'Compare uplights, moving heads, spotlights, and effects.' },
        { icon: 'calendar', title: 'Select dates', description: 'Tell us when and where you need it.' },
        { icon: 'truck', title: 'Pickup or delivery', description: 'Collect it or schedule professional delivery and setup.' },
        { icon: 'success', title: 'Event ready', description: 'Receive tested fixtures with local technical support.' }
    ]
    console.log('SUBCA', subCate)
    return <>
          <BreadcrumbJsonLd
        itemListElements={[
          { position: 1, name: "Home", item: `https://miamisoundrental.com` },

          { position: 2, name: "Lighting Rental", item: `https://miamisoundrental.com/lighting-rental` },
        ]}
      />
        <NextSeo
            title='Event Lighting Rental in Florida | Miami & Orlando'
            description='Rent uplights, moving heads, spotlights, gobo projectors and event lighting from our Miami or Orlando store. Compare pickup and delivery options online.'
            canonical="https://miamisoundrental.com/lighting-rental"
            twitter={{
                handle: '@miamisoundrent1',
                site: '@miamisoundrent1',
                cardType: 'summary_large_image',
            }}
            openGraph={{
                type: 'website',
                url: `https://miamisoundrental.com/lighting-rental`,
                title: 'Event Lighting Rental in Florida | Miami & Orlando',
                description: 'Rent uplights, moving heads, spotlights, gobo projectors and event lighting from our Miami or Orlando store. Compare pickup and delivery options online.',
                images: [
                    {
                        url: 'https://miamisoundrental.com/Pictures/categories-v2/lighting-rental-hero-v2.jpg',
                        width: 1915,
                        height: 821,
                        alt: 'Professional event lighting fixtures mounted on an outdoor truss in Miami',
                    },

                ],
                site_name: 'Miami Sound Rental',
            }}
        />
        <div className='categoryRental projectorRental'>
            <PageShell>
                <ServiceHero
                    eyebrow='Event lighting rental · Miami & Orlando'
                    title='Lighting Rental'
                    description='Compare uplights, moving heads, spotlights and event lighting for weddings, concerts, meetings and celebrations. Inventory and fulfillment update for your selected Florida store.'
                    image={{ src: lightingRentalHeroV2, position: 'center' }}
                    imageAlt='Professional event lighting fixtures mounted on an outdoor truss in Miami'
                    primaryAction={{
                        label: 'Browse Lighting',
                        href: '#productsAnchor',
                        icon: FiSun,
                        conversionKey: 'lighting-rental.hero.browse-lighting',
                        channel: 'rental',
                        salesPath: 'self_service',
                        onClick: () => gtag.event({
                            action: 'catalog_click',
                            label: 'leads',
                            value: 2,
                            category: 'orders'
                        })
                    }}
                    secondaryAction={{
                        label: 'Talk to an Expert',
                        icon: FiMessageCircle,
                        conversionKey: 'lighting-rental.hero.talk-to-expert',
                        channel: 'quote',
                        salesPath: 'managed',
                        onClick: openQuote
                    }}
                    processLabel='How lighting rental works'
                    steps={heroSteps}
                />
            </PageShell>
            <MarketCoverageNotice content={sharedCatalogCoverage} />

            <PageShell>
                <ServiceOverview
                    content={lightingOverviewContent}
                    supportingContent={<SimilarCats ui='v2' priority noTitle className='noMargin split' subCate={subCate} newStyle />}
                />
            </PageShell>




            <section className='stageType white'>
      <ProductList

           carousel={{
                    name: 'Lighting Rentals',
                    url: 'https://miamisoundrental.com/lighting-rental',
                    description: 'Stage Lighting Bundles and Fixtures'
                }}
      listName='Lighting Fixture Bundles' anchor products={products.filter(p => p.categories?.includes('Lighting/Bundle'))} />
      <NotSure />
            </section>
            <PageShell>
                <ServiceOverview
                    content={lightingPackagesOverviewContent}
                    supportingContent={
                        <Carrousel ui='v2' minus className='whitePacks' size={3} array={packages?.filter(p => p.tags?.includes('lighting'))?.sort((a, b) => b.price - a.price).map((pack) => <SinglePack ui='v2' key={pack._id} pack={pack} />)} />
                    }
                />
            </PageShell>



                <LandingCategories ui='v2' loading='lazy' title className='padBottom padTop' options category='lighting' />
            <section className='stageType'>


            <div className='tripleBlock'>
                    <div className='imageSplit f2'>
                        <div className=' second'>

                            <div className='title'>Stage Lighting</div>
                            <div className='sub'>  Stage lighting enhances performances, creates dynamic visual effects, and sets the mood for live events.</div>
                            <div>
                            <ul>
                                    <li><strong>Spotlights:</strong> Used to highlight performers or specific areas of the stage.</li>
                                    <li><strong>Moving Heads:</strong> Provide versatility with their ability to move, change colors, and create various lighting patterns.</li>
                                    <li><strong>Wash Lights:</strong> Offer broad, even stage coverage with colored lighting.</li>
                                    <li><strong>Effects Lighting:</strong> Used to create dramatic effects, such as strobe lights, fog or haze machines, lasers, and other specialized effect fixtures.</li>
                                </ul>

                            </div>
                        </div>
                        <div className='imgBG'>
                            <PicCont background width={400} height={800} src={lighting_c} />
                        </div>
                    </div>
                    <div className='col f3'>
                        <BGBlock src={lighting_b} className='second'>
                            <div className='title'>DJ Lighting</div>
                            <div className='sub'>  DJ lighting is specifically designed to complement the music and enhance the performance of a DJ or electronic music artist.</div>
                            <div>
                            <ul>
                                    <li><strong>Moving Heads: </strong> These dynamic fixtures create moving beams, patterns, and shapes that synchronize with the music beats.</li>

                                    <li><strong>Black Lights / UV Lights: </strong>Used to create a glow-in-the-dark effect.</li>
                                    <li><strong>Strobe Lights: </strong>Fast and intense bursts of light accentuate the music&apos;s energetic moments.</li>
                                </ul>
                            </div>
                        </BGBlock>
                        <div className='second border row'>
                            <div className='f1 col left'>
                                <div className='title'>Party & Wedding Lighting</div>
                                <div >    Party lighting focuses on creating a lively, energetic atmosphere for social gatherings such as birthdays, weddings, or celebrations. The emphasis is on creating a festive and engaging ambiance.</div>
                            </div>
                            <div className='f2'>
                            <ul>
                                    <li><strong>Uplighting: </strong>Lights on the floor, shining upwards to highlight walls or architectural features.</li>
                                    <li><strong>Moving Heads: </strong> Project customized designs or patterns onto walls or the dance floor.</li>
                                    <li><strong>Monogram/Gobo Lighting: </strong> Projection of custom monograms, graphics or logos into flat surfaces.</li>
                                    <li><strong>Spotlights: </strong> Focusing attention on specific areas or objects.</li>
                                    <li><strong>Effects Lighting: </strong>Strobe lights, lasers, fog machines, or bubble machines enhance the party atmosphere and add excitement.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <RentalFAQV2 questions={faq} headingId='lighting-rental-faq-title' />
            <PastEvents ui='v2' filter={['concert', 'fashion', 'party']} newsletterevents={newsletterevents} total_events={total_events} />
            <ClientReviews ui='v2' />
        </div>
    </>
}

export default LightingRental
